import { CircleAlert, CircleCheck, CircleX, Info } from "lucide-react";
import type * as React from "react";
import { cn } from "./lib/cn";

const variants = {
  success: {
    icon: CircleCheck,
    className: "border-success-border bg-success-soft text-success",
  },
  warning: {
    icon: CircleAlert,
    className: "border-warning-border bg-warning-soft text-warning",
  },
  error: { icon: CircleX, className: "border-error-border bg-error-soft text-error" },
  information: {
    icon: Info,
    className: "border-information-border bg-information-soft text-information",
  },
} as const;

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof variants;
  title: string;
}

export function Alert({
  variant = "information",
  title,
  children,
  className,
  ...props
}: AlertProps) {
  const config = variants[variant];
  const Icon = config.icon;
  return (
    <div
      className={cn("rounded-control flex gap-3 border p-4", config.className, className)}
      {...props}
    >
      <Icon aria-hidden="true" className="mt-0.5 size-5 shrink-0" strokeWidth={2} />
      <div>
        <p className="font-semibold">{title}</p>
        {children && <div className="text-small text-text mt-1">{children}</div>}
      </div>
    </div>
  );
}
